import { Button } from "PFComponents/button";
import { CarouselBaseProps } from "PFComponents/carousel/carousel_base";
import { Icon } from "PFComponents/icon";
import { LoadingDots } from "PFComponents/loading_dots";
import { useUpcomingBookings } from "PFCore/hooks/queries/activities/marketplace/use_marketplace_upcoming_bookings";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { Tile } from "../../components";
import { Carousel } from "../../components/carousel";
import { NoBookingsScreen } from "./no_bookings_screen";
import { UpcomingRoleCard } from "./upcoming_role_card";
import css from "./upcoming_roles.module.scss";

export const UpcomingRoles = () => {
  const { data: currentProfile } = useCurrentProfile();
  const { t } = useTranslation("marketplace", { keyPrefix: "dashboard.upcomingRoles" });
  const { data, isLoading } = useUpcomingBookings(currentProfile.id);
  const history = useHistory();

  const carouselItems: CarouselBaseProps["items"] = useMemo(
    () =>
      (data?.entries || []).map((booking) => ({
        id: booking.bookingId,
        content: <UpcomingRoleCard booking={booking} />
      })),
    [data?.entries]
  );

  return (
    <Tile
      title={t("title")}
      headerAdditionalContent={
        <Button kind="blank" onClick={() => history.push("/profiles/me")} className={css.calendarButton}>
          <Icon name="calendar" size="sm" />
        </Button>
      }
    >
      <div className={css.mainContainer}>
        {isLoading && <LoadingDots circlesEnabled circleSize="xs" />}
        {carouselItems.length > 0 && <Carousel items={carouselItems} />}
        {!isLoading && data?.entries?.length === 0 && <NoBookingsScreen />}
      </div>
    </Tile>
  );
};
